/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Textbox from '../Textbox/Textbox';

/**
 * Represents the Numericbox component.
 */

export default class Numericbox extends Textbox {

    /**
     * Properties.
     */

    static propTypes = {
        decimalseparator:   PropTypes.array,
        isfloat:            PropTypes.bool,
        isnegative:         PropTypes.bool,
        invalidmessage:     PropTypes.string
    }

    /**
     * Default property values.
     */

    static defaultProps = {
        decimalseparator:   [190, '.'],
        invalidmessage:     'Invalid number'
    }

    /**
     * Gets the value of the numericbox.
     *
     * @returns {String}  value   value of the numericbox
     */

    getValue = () => {

        // Getting the value of the numericbox

        if (this.input.value === '') {
            return null;
        } else {
            return this.props.isfloat ? parseFloat(this.input.value) : parseInt(this.input.value, 10);
        }
    }

    /**
     * Sets the value of the numericbox.
     *
     * @param {String}  value   value of the numericbox
     */

    setValue = (value) => {
      
        // Setting the value of the numericbox

        this.input.value = '' + value;
        this.validate();
    }

    /**
     * Event that fires when the component mounted.
     */

    componentDidMount = () => {

        // Setting the key handler

        ReactDOM.findDOMNode(this).addEventListener('keydown', event => {

            // Getting the code of the pressed key
            
            let keycode = event.keyCode ? event.keyCode : event.which;

            // Allow BACKSPACE, DELETE, TAB, ESCAPE, ENTER

            if ([46, 8, 9, 27, 13, 110].indexOf(keycode) >= 0) {
                return;
            }

            // Allow: Ctrl/cmd+A

            if ((keycode === 65 && (event.ctrlKey === true || event.metaKey === true)) ||
              // Allow: Ctrl/cmd+C
              (keycode === 67 && (event.ctrlKey === true || event.metaKey === true)) ||
              // Allow: Ctrl/cmd+X
              (keycode === 88 && (event.ctrlKey === true || event.metaKey === true)) ||
              // Allow: Ctrl/cmd+V
              (keycode === 86 && (event.ctrlKey === true || event.metaKey === true))) {
              return;
            }

            // Allow: HOME, END, LEFT, RIGHT

            if (keycode >= 35 && keycode <= 39) {
                return;
            }

            // Getting the value of the numericbox

            let value = this.input.value;

            // Checking the pressed key

            if ((keycode >= 48 && keycode <= 57 && !event.shiftKey) || // Number
            (keycode >= 96 && keycode <= 105 && !event.shiftKey) || // Numeric pad number
            (this.props.isnegative && keycode === 189 && (keycode.length === 0 ||
            (value.indexOf('-') < 0 && this.input.selectionStart === 0))) || // Negative sign
            (this.props.isfloat && keycode === this.props.decimalseparator[0] && // Decimal separator
            value.indexOf(this.props.decimalseparator[1]) < 0 && value !== '-')) {
                return;
            }

            // Prevent the typing

            event.preventDefault();
        });
    }

    /**
     * Validates the numericbox.
     * 
     * @param     {String}  value   value that has to check (optional)
     * @returns   {Boolean} valid   specified value or the value of the numericbox is
     *                              valid or not
     */

    validate = (value) => {

        // Does the value of the numericbox valid?

        if (!(this.props.isrequired && this.isEmpty(value))) {
            if (!this.isEmpty(value)) {

                // Getting the value of the numericbox

                let v = value || this.input.value;
                
                // Is it a negative number?

                if (!this.props.isnegative) {
                    if (v.indexOf('-') >= 0) {
                        if (!value) {
                            this.setError(this.props.invalidmessage);
                        }

                        return false;
                    }
                }

                // Is it a real float?

                if (this.props.isfloat) {
                    if (v !== parseFloat(v).toString()) {
                        if (!value) {
                            this.setError(this.props.invalidmessage);
                        }

                        return false;
                    }
                } else {

                    // Is it a real integer?

                    if (v !== parseInt(v, 10).toString()) {
                        if (!value) {
                            this.setError(this.props.invalidmessage);
                        }

                        return false;
                    }
                }
            }

            // Numericbox is valid

            if (!value) {
                this.clearError();
            }
            
            return true;
        } else {
            if (!value) {

                // Numericbox is invalid

                this.setError(this.getRequiredMessage());
            }

            return false;
        }
    }    
}



// WEBPACK FOOTER //
// ./src/components/Numericbox/Numericbox.js